import gql from "graphql-tag";

const GetPortsDepartureShippingRequests = gql`
  query(
    $port_id: Int!
    $port_of_loading_status: ShippingRequestPortOfLoadingStatus!
    $count: Int
    $page: Int
  ) {
    GetAllPortOfLoadingRequestsForAPort(
      port_id: $port_id
      port_of_loading_status: $port_of_loading_status
      count: $count
      page: $page
    ) {
      data {
        id
        user_id
        status
        port_status
        reference_number
        number_of_dg_commodities_coloaded_in_container
        shipper_name
        shipper_address
        shipper_email
        consignee_email
        consignee_phone_number
        consignee_name
        consignee_address
        shipper_phone_number
        ship_name
        voyage_number
        port_of_loading
        port_of_discharge_id
        additional_handling_information
        date_of_arrival
        date_of_departure
        shipper_declaration_company_name
        shipper_declaration_name_of_declarant
        shipper_declaration_status_of_declarant
        shipper_declaration_date
        additional_handling_information
        certificate_documents {
          file_url
          file_name
          id
        }
        dangerousGoods {
          id
          chemical_name
          sub_risk
          flash_point
          marine_pollutant
          limited_quantity
          temperature_controlled
          control_temperature
          emergency_temperature
          empty_laden_tank
          net_explosive_quantity
          imdg_code_segregation_group
          container_operator
          container_type
          container_size
          dangerous_good_info {
            id
            un_number
            proper_shipping_name
            imo_class
            packing_group
          }
          dangerous_good_packaging {
            id
            gross_mass
            net_mass
            volume
            outer_packaging
            inner_packaging
          }
          created_at
          updated_at
        }
      }
      paginatorInfo {
        count
        currentPage
        firstItem
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export default GetPortsDepartureShippingRequests;
